<div class="pssr-form-inline-control">
  <div class="pssr-form-label">{{ 'common.language' | translate }}</div>
  <p-select
    [options]="languagesList()"
    [(ngModel)]="selectedLanguage"
    (ngModelChange)="onLanguageChange($event)"
    name="languages"
    styleClass="pssr-dropdown pssr-dropdown--small">
    <ng-template
      #selectedItem
      let-lang>
      <div class="language__selected">
        <i class="pi pi-globe"></i>
        &nbsp;{{ lang.value | uppercase }}
      </div>
    </ng-template>
  </p-select>
</div>
